<template>
  <div class="flex items-start gap-2">
    <div class="flex size-6 shrink-0 items-center justify-center rounded-full bg-[#00022B]">
      <img alt="Wabunka" class="size-5" height="20" src="@/assets/logo/wabunka/symbol.svg" width="20" />
    </div>
    <div class="min-w-0 max-w-[calc(100%-44px)]">
      <ChatMessageRenderer :blocks="blocks" :disabled="disabled" @click-navigation="$emit('clickNavigation', $event)" @select-tag="$emit('selectTag', $event)" />
    </div>
  </div>
</template>

<script setup lang="ts">
import ChatMessageRenderer from '@/wabunka-src/features/Chat/components/model/pure/ChatMessageRenderer/ChatMessageRenderer.vue';
import type { MessageBlock } from '@/wabunka-src/features/Chat/models/chatMessage';

interface Props {
  blocks: MessageBlock[];
  disabled?: boolean;
}

withDefaults(defineProps<Props>(), {
  disabled: false,
});

defineEmits<{
  selectTag: [tag: string];
  clickNavigation: [payload: { navType: string; url?: string; label?: string }];
}>();
</script>
